export default __webpack_public_path__ + "static/media/MaskGroup18.d63cbcc4.svg";